import { type ItcStatus, toDecimal } from '@mm/shared';

/**
 * GST input credit buckets for the GST card:
 *   Total GST  = all GST paid on marketing
 *   Eligible   = ELIGIBLE + CLAIMED (+ legacy PENDING_VERIFICATION rows)
 *   Claimed    = CLAIMED
 *   Remaining  = Eligible − Claimed
 * Not-eligible and reversed GST count in the total only.
 */
export function itcBuckets(total: string, byStatus: Partial<Record<ItcStatus, string>>) {
  const v = (k: ItcStatus) => toDecimal(byStatus[k] ?? '0');
  const remaining = v('ELIGIBLE').plus(v('PENDING_VERIFICATION'));
  const claimed = v('CLAIMED');
  return {
    total: toDecimal(total).toString(),
    eligible: remaining.plus(claimed).toString(),
    claimed: claimed.toString(),
    remaining: remaining.toString(),
  };
}
